var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssassin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlLang: "en",
    viewBox: "-4 -5 8 9",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .assassin-fill {\n      stroke: none;\n      fill: inherit;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "assassin-right",
    className: "assassin-fill",
    d: "M0 -5       l2 4       q0.7,1.3 2,1       q-0.4,1 0,2       q-0.4,-0.2 -1,0.1       q-0.7,0.5 -2.5,1       q2.3,-0.8 1.7,-2.2       l-2.2 -5       Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "assassin-left",
    className: "assassin-fill",
    d: "M0 -5       l-2 4       q-0.7,1.3 -2,1       q0.4,1 0,2       q0.4,-0.2 1,0.1       q0.7,0.5 2.5,1       q-2.3,-0.8 -1.7,-2.2       l2.2 -5       Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "assassin-bottom",
    className: "assassin-fill",
    d: "M0 3       q0.5,1 3.5,-0.3       q-3.5,2.5 -7,0       q3,1.3 3.5,0.3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssassin);
export default __webpack_public_path__ + "static/media/assassin.cebc3d845525cc03a3f53fd30aafae78.svg";
export { ForwardRef as ReactComponent };